//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SavingsGoalsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SavingsGoalsGetSavingsGoalsQueryParameters = {
  id: string ;
}

export type SavingsGoalsUpdateSavingsGoalsQueryParameters = {
  id: string ;
}

export type SavingsGoalsDeleteSavingsGoalsQueryParameters = {
  id: string ;
}

export type SavingsGoalsGetSavingsGoalPreviewSavingsGoalsQueryParameters = {
  name: string ;
  startDate: string ;
  endDate: string ;
  goalValue: number ;
  portfolios: string[] ;
  currency?: string | undefined ;
  contribution?: number | undefined ;
  contributionType?: Types.ContributionType | undefined ;
  annualReturns?: number | undefined ;
}

export type SavingsGoalsGetSavingsGoalProgressSavingsGoalsQueryParameters = {
  id: string ;
}

export function savingsGoalsGetListUrl(): string {
  let url_ = getBaseUrl() + "/api/savings-goals";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let savingsGoalsGetListDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryFn'>> = {
};
export function getSavingsGoalsGetListDefaultOptions() {
  return savingsGoalsGetListDefaultOptions;
};
export function setSavingsGoalsGetListDefaultOptions(options: typeof savingsGoalsGetListDefaultOptions) {
  savingsGoalsGetListDefaultOptions = options;
}

export function savingsGoalsGetListQueryKey(): QueryKey;
export function savingsGoalsGetListQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'SavingsGoalsClient',
      'savingsGoalsGetList',
    ]);
}
export function __savingsGoalsGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.savingsGoalsGetList(
axiosConfig    );
}

/**
 * @return OK
 */
export function useSavingsGoalsGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSavingsGoalsGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __savingsGoalsGetList(context, axiosConfig) : __savingsGoalsGetList,
    queryKey: savingsGoalsGetListQueryKey(),
    ...savingsGoalsGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setSavingsGoalsGetListData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid, ) {
  queryClient.setQueryData(savingsGoalsGetListQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setSavingsGoalsGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function savingsGoalsGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/savings-goals/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let savingsGoalsGetDefaultOptions: Omit<UseQueryOptions<Types.SavingsGoalDto, unknown, Types.SavingsGoalDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SavingsGoalDto, unknown, Types.SavingsGoalDto>, 'queryFn'>> = {
};
export function getSavingsGoalsGetDefaultOptions() {
  return savingsGoalsGetDefaultOptions;
};
export function setSavingsGoalsGetDefaultOptions(options: typeof savingsGoalsGetDefaultOptions) {
  savingsGoalsGetDefaultOptions = options;
}

export function savingsGoalsGetQueryKey(id: string): QueryKey;
export function savingsGoalsGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as SavingsGoalsGetSavingsGoalsQueryParameters;

    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGet',
        ...params
      ]);
  }
}
export function __savingsGoalsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.savingsGoalsGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useSavingsGoalsGetQuery<TSelectData = Types.SavingsGoalDto, TError = unknown>(dto: SavingsGoalsGetSavingsGoalsQueryParameters, options?: Omit<UseQueryOptions<Types.SavingsGoalDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useSavingsGoalsGetQuery<TSelectData = Types.SavingsGoalDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.SavingsGoalDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSavingsGoalsGetQuery<TSelectData = Types.SavingsGoalDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SavingsGoalDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as SavingsGoalsGetSavingsGoalsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SavingsGoalDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __savingsGoalsGet(context, axiosConfig) : __savingsGoalsGet,
    queryKey: savingsGoalsGetQueryKey(id),
    ...savingsGoalsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.SavingsGoalDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setSavingsGoalsGetData(queryClient: QueryClient, updater: (data: Types.SavingsGoalDto | undefined) => Types.SavingsGoalDto, id: string) {
  queryClient.setQueryData(savingsGoalsGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setSavingsGoalsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SavingsGoalDto | undefined) => Types.SavingsGoalDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function savingsGoalsUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/savings-goals/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function savingsGoalsUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SavingsGoalsClient',
      'savingsGoalsUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useSavingsGoalsUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.SavingsGoalDto, unknown, Types.SavingsGoalCreateOrUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SavingsGoalDto, unknown, Types.SavingsGoalCreateOrUpdateDto, TContext> {
  const key = savingsGoalsUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SavingsGoalCreateOrUpdateDto) => Client.savingsGoalsUpdate(id, body),
    mutationKey: key,
  });
}
  
type SavingsGoalsUpdate__MutationParameters = SavingsGoalsUpdateSavingsGoalsQueryParameters & {
  body: Types.SavingsGoalCreateOrUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useSavingsGoalsUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SavingsGoalDto, unknown, SavingsGoalsUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SavingsGoalsUpdateSavingsGoalsQueryParameters}): UseMutationResult<Types.SavingsGoalDto, unknown, SavingsGoalsUpdate__MutationParameters, TContext> {
  const key = savingsGoalsUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SavingsGoalsUpdate__MutationParameters) => Client.savingsGoalsUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function savingsGoalsDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/savings-goals/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function savingsGoalsDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'SavingsGoalsClient',
      'savingsGoalsDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useSavingsGoalsDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = savingsGoalsDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.savingsGoalsDelete(id),
    mutationKey: key,
  });
}
  
type SavingsGoalsDelete__MutationParameters = SavingsGoalsDeleteSavingsGoalsQueryParameters

/**
 * @return OK
 */
export function useSavingsGoalsDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SavingsGoalsDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SavingsGoalsDeleteSavingsGoalsQueryParameters}): UseMutationResult<void, unknown, SavingsGoalsDelete__MutationParameters, TContext> {
  const key = savingsGoalsDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SavingsGoalsDelete__MutationParameters) => Client.savingsGoalsDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function savingsGoalsGetSavingsGoalPreviewUrl(name: string, startDate: string, endDate: string, goalValue: number, portfolios: string[], currency?: string | undefined, contribution?: number | undefined, contributionType?: Types.ContributionType | undefined, annualReturns?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/savings-goals/preview?";
  if (name === undefined || name === null)
    throw new Error("The parameter 'name' must be defined and cannot be null.");
  else
    url_ += "Name=" + encodeURIComponent("" + name) + "&";
  if (startDate === undefined || startDate === null)
    throw new Error("The parameter 'startDate' must be defined and cannot be null.");
  else
    url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
  if (endDate === undefined || endDate === null)
    throw new Error("The parameter 'endDate' must be defined and cannot be null.");
  else
    url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
  if (goalValue === undefined || goalValue === null)
    throw new Error("The parameter 'goalValue' must be defined and cannot be null.");
  else
    url_ += "GoalValue=" + encodeURIComponent("" + goalValue) + "&";
  if (portfolios === undefined || portfolios === null)
    throw new Error("The parameter 'portfolios' must be defined and cannot be null.");
  else
    portfolios && portfolios.forEach(item => { url_ += "Portfolios=" + encodeURIComponent("" + item) + "&"; });
if (currency === null)
    throw new Error("The parameter 'currency' cannot be null.");
else if (currency !== undefined)
    url_ += "Currency=" + encodeURIComponent("" + currency) + "&";
if (contribution === null)
    throw new Error("The parameter 'contribution' cannot be null.");
else if (contribution !== undefined)
    url_ += "Contribution=" + encodeURIComponent("" + contribution) + "&";
if (contributionType === null)
    throw new Error("The parameter 'contributionType' cannot be null.");
else if (contributionType !== undefined)
    url_ += "ContributionType=" + encodeURIComponent("" + contributionType) + "&";
if (annualReturns === null)
    throw new Error("The parameter 'annualReturns' cannot be null.");
else if (annualReturns !== undefined)
    url_ += "AnnualReturns=" + encodeURIComponent("" + annualReturns) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let savingsGoalsGetSavingsGoalPreviewDefaultOptions: Omit<UseQueryOptions<Types.SavingsGoalPreviewDto, unknown, Types.SavingsGoalPreviewDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SavingsGoalPreviewDto, unknown, Types.SavingsGoalPreviewDto>, 'queryFn'>> = {
};
export function getSavingsGoalsGetSavingsGoalPreviewDefaultOptions() {
  return savingsGoalsGetSavingsGoalPreviewDefaultOptions;
};
export function setSavingsGoalsGetSavingsGoalPreviewDefaultOptions(options: typeof savingsGoalsGetSavingsGoalPreviewDefaultOptions) {
  savingsGoalsGetSavingsGoalPreviewDefaultOptions = options;
}

export function savingsGoalsGetSavingsGoalPreviewQueryKey(dto: SavingsGoalsGetSavingsGoalPreviewSavingsGoalsQueryParameters): QueryKey;
export function savingsGoalsGetSavingsGoalPreviewQueryKey(name: string, startDate: string, endDate: string, goalValue: number, portfolios: string[], currency?: string | undefined, contribution?: number | undefined, contributionType?: Types.ContributionType | undefined, annualReturns?: number | undefined): QueryKey;
export function savingsGoalsGetSavingsGoalPreviewQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { name, startDate, endDate, goalValue, portfolios, currency, contribution, contributionType, annualReturns,  } = params[0] as SavingsGoalsGetSavingsGoalPreviewSavingsGoalsQueryParameters;

    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGetSavingsGoalPreview',
        name as any,
        startDate as any,
        endDate as any,
        goalValue as any,
        portfolios as any,
        currency as any,
        contribution as any,
        contributionType as any,
        annualReturns as any,
      ]);
  } else {
    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGetSavingsGoalPreview',
        ...params
      ]);
  }
}
export function __savingsGoalsGetSavingsGoalPreview(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.savingsGoalsGetSavingsGoalPreview(
      context.queryKey[2] as string,       context.queryKey[3] as string,       context.queryKey[4] as string,       context.queryKey[5] as number,       context.queryKey[6] as string[],       context.queryKey[7] as string | undefined,       context.queryKey[8] as number | undefined,       context.queryKey[9] as Types.ContributionType | undefined,       context.queryKey[10] as number | undefined,axiosConfig    );
}

export function useSavingsGoalsGetSavingsGoalPreviewQuery<TSelectData = Types.SavingsGoalPreviewDto, TError = unknown>(dto: SavingsGoalsGetSavingsGoalPreviewSavingsGoalsQueryParameters, options?: Omit<UseQueryOptions<Types.SavingsGoalPreviewDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param currency (optional) 
 * @param contribution (optional) 
 * @param contributionType (optional) 
 * @param annualReturns (optional) 
 * @return OK
 */
export function useSavingsGoalsGetSavingsGoalPreviewQuery<TSelectData = Types.SavingsGoalPreviewDto, TError = unknown>(name: string, startDate: string, endDate: string, goalValue: number, portfolios: string[], currency?: string | undefined, contribution?: number | undefined, contributionType?: Types.ContributionType | undefined, annualReturns?: number | undefined, options?: Omit<UseQueryOptions<Types.SavingsGoalPreviewDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSavingsGoalsGetSavingsGoalPreviewQuery<TSelectData = Types.SavingsGoalPreviewDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SavingsGoalPreviewDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let name: any = undefined;
  let startDate: any = undefined;
  let endDate: any = undefined;
  let goalValue: any = undefined;
  let portfolios: any = undefined;
  let currency: any = undefined;
  let contribution: any = undefined;
  let contributionType: any = undefined;
  let annualReturns: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ name, startDate, endDate, goalValue, portfolios, currency, contribution, contributionType, annualReturns,  } = params[0] as SavingsGoalsGetSavingsGoalPreviewSavingsGoalsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [name, startDate, endDate, goalValue, portfolios, currency, contribution, contributionType, annualReturns, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SavingsGoalPreviewDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __savingsGoalsGetSavingsGoalPreview(context, axiosConfig) : __savingsGoalsGetSavingsGoalPreview,
    queryKey: savingsGoalsGetSavingsGoalPreviewQueryKey(name, startDate, endDate, goalValue, portfolios, currency, contribution, contributionType, annualReturns),
    ...savingsGoalsGetSavingsGoalPreviewDefaultOptions as unknown as Omit<UseQueryOptions<Types.SavingsGoalPreviewDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param currency (optional) 
 * @param contribution (optional) 
 * @param contributionType (optional) 
 * @param annualReturns (optional) 
 * @return OK
 */
export function setSavingsGoalsGetSavingsGoalPreviewData(queryClient: QueryClient, updater: (data: Types.SavingsGoalPreviewDto | undefined) => Types.SavingsGoalPreviewDto, name: string, startDate: string, endDate: string, goalValue: number, portfolios: string[], currency?: string | undefined, contribution?: number | undefined, contributionType?: Types.ContributionType | undefined, annualReturns?: number | undefined) {
  queryClient.setQueryData(savingsGoalsGetSavingsGoalPreviewQueryKey(name, startDate, endDate, goalValue, portfolios, currency, contribution, contributionType, annualReturns),
    updater
  );
}

/**
 * @param currency (optional) 
 * @param contribution (optional) 
 * @param contributionType (optional) 
 * @param annualReturns (optional) 
 * @return OK
 */
export function setSavingsGoalsGetSavingsGoalPreviewDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SavingsGoalPreviewDto | undefined) => Types.SavingsGoalPreviewDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function savingsGoalsGetSavingsGoalProgressUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/savings-goals/{id}/progress";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let savingsGoalsGetSavingsGoalProgressDefaultOptions: Omit<UseQueryOptions<Types.SavingsGoalCalculationDto, unknown, Types.SavingsGoalCalculationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SavingsGoalCalculationDto, unknown, Types.SavingsGoalCalculationDto>, 'queryFn'>> = {
};
export function getSavingsGoalsGetSavingsGoalProgressDefaultOptions() {
  return savingsGoalsGetSavingsGoalProgressDefaultOptions;
};
export function setSavingsGoalsGetSavingsGoalProgressDefaultOptions(options: typeof savingsGoalsGetSavingsGoalProgressDefaultOptions) {
  savingsGoalsGetSavingsGoalProgressDefaultOptions = options;
}

export function savingsGoalsGetSavingsGoalProgressQueryKey(id: string): QueryKey;
export function savingsGoalsGetSavingsGoalProgressQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as SavingsGoalsGetSavingsGoalProgressSavingsGoalsQueryParameters;

    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGetSavingsGoalProgress',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'SavingsGoalsClient',
        'savingsGoalsGetSavingsGoalProgress',
        ...params
      ]);
  }
}
export function __savingsGoalsGetSavingsGoalProgress(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.savingsGoalsGetSavingsGoalProgress(
      context.queryKey[2] as string,axiosConfig    );
}

export function useSavingsGoalsGetSavingsGoalProgressQuery<TSelectData = Types.SavingsGoalCalculationDto, TError = unknown>(dto: SavingsGoalsGetSavingsGoalProgressSavingsGoalsQueryParameters, options?: Omit<UseQueryOptions<Types.SavingsGoalCalculationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useSavingsGoalsGetSavingsGoalProgressQuery<TSelectData = Types.SavingsGoalCalculationDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.SavingsGoalCalculationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSavingsGoalsGetSavingsGoalProgressQuery<TSelectData = Types.SavingsGoalCalculationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SavingsGoalCalculationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as SavingsGoalsGetSavingsGoalProgressSavingsGoalsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SavingsGoalCalculationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __savingsGoalsGetSavingsGoalProgress(context, axiosConfig) : __savingsGoalsGetSavingsGoalProgress,
    queryKey: savingsGoalsGetSavingsGoalProgressQueryKey(id),
    ...savingsGoalsGetSavingsGoalProgressDefaultOptions as unknown as Omit<UseQueryOptions<Types.SavingsGoalCalculationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setSavingsGoalsGetSavingsGoalProgressData(queryClient: QueryClient, updater: (data: Types.SavingsGoalCalculationDto | undefined) => Types.SavingsGoalCalculationDto, id: string) {
  queryClient.setQueryData(savingsGoalsGetSavingsGoalProgressQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setSavingsGoalsGetSavingsGoalProgressDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SavingsGoalCalculationDto | undefined) => Types.SavingsGoalCalculationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function savingsGoalsCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/savings-goals/create";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function savingsGoalsCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'SavingsGoalsClient',
      'savingsGoalsCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useSavingsGoalsCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.SavingsGoalDto, unknown, Types.SavingsGoalCreateOrUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SavingsGoalDto, unknown, Types.SavingsGoalCreateOrUpdateDto, TContext> {
  const key = savingsGoalsCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SavingsGoalCreateOrUpdateDto) => Client.savingsGoalsCreate(body),
    mutationKey: key,
  });
}